import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { FiAlignJustify } from 'react-icons/fi';
import { RxInstagramLogo } from 'react-icons/rx';
import { RiFacebookLine } from 'react-icons/ri';
import { LiaTelegramPlane } from 'react-icons/lia';
import { LiaPhoneVolumeSolid } from 'react-icons/lia';
import { IoMdClose } from 'react-icons/io';
export const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 214px;
  margin-top: 40px;

  @media (min-width: 768px) {
    height: 100px;
  }
`;
export const LeftConatiner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const RightContainer = styled.div`
  margin: 0;
  display: none;
  @media (min-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  @media (min-width: 1024px) {
  }
  @media (min-width: 1201px) {
  }
`;
export const Navigation = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  margin: 0;
  @media (min-width: 768px) {
    justify-content: space-between;
    flex-direction: unset;
  }
`;
export const NavItem = styled.li`
  list-style-type: none;
  cursor: pointer;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 66px;
  color: #ffffff;
  @media (min-width: 768px) {
    font-size: 10px;
    line-height: 66px;
    margin-right: 15px;
  }
  @media (min-width: 1400px) {
    font-size: 20px;
    margin-right: 25px;
  }
`;
export const NavSpan = styled.span`
  position: relative;
  text-decoration: none;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 66px;
  color: #ffffff;
  @media (min-width: 768px) {
    font-size: 10px;
    line-height: 66px;
  }
  @media (min-width: 1400px) {
    font-size: 19px;
  }
  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -4px;
    width: 100%;
    height: 2px;
    background-color: transparent;
    transition: background-color 0.3s ease;
  }
  &:hover::after {
    background-color: #ffc300;
  }
`;
export const ImgLogo = styled.img`
  width: 90px;
  height: 25px;
  cursor: pointer;

  @media (min-width: 850px) {
    width: 130px;
    height: 30px;
  }
  @media (min-width: 980px) {
    width: 200px;
    height: 40px;
  }
`;
export const LogoLink = styled(NavLink)`
  width: 112px;
  height: 25px;
`;
export const MenuConteiner = styled.div`
  position: relative;
`;
export const Menu = styled.div`
  position: absolute;
  background-color: #ffc300;
  box-shadow: 0px 4px 12.3px rgba(0, 0, 0, 0.16);
  width: 185px;
  left: -25px;
  top: 50px;
  z-index: 2;
  @media (min-width: 768px) {
    left: -20px;
    top: 50px;
  }
  @media (min-width: 1200px) {
    left: -18px;
    top: 50px;
  }
  @media (min-width: 1400px) {
    left: -8px;
    top: 55px;
  }
`;
export const HeaderList = styled.ul`
  list-style: none;
  padding: 0;
`;
export const HeaderItem = styled.li`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #232629;
  padding-left: 8px;
  height: 36px;
  display: flex;
  align-items: center;
  &:hover {
    cursor: pointer;

    background-color: #001d3d;
  }
`;
export const Link = styled(NavLink)`
  text-decoration: none;
  color: #ffffff;
  width: 100%;
`;
export const MenuIcon = styled(FiAlignJustify)`
  width: 25px;
  height: 25px;
  cursor: pointer;

  color: #ffff;
`;
export const CloseIcon = styled(IoMdClose)`
  width: 25px;
  height: 25px;
  cursor: pointer;

  color: #ffff;
`;
export const MobileMenu = styled.div`
  position: absolute;
  top: 180px;
  left: 0;
  right: 0;
  background: #071729;
  z-index: 1000;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
`;
export const StyledLink = styled.a`
  text-decoration: none;
  color: #ffffff;
  display: flex;
  align-items: center;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 300%;
  text-align: center;
  @media (min-width: 1200px) {
    font-size: 16px;
  }
`;
export const InstIcon = styled(RxInstagramLogo)`
  width: 20px;
  height: 20px;
  color: #ffffff;
  transition: color 0.3s;
  margin-right: 8px;
  @media (min-width: 768px) {
    margin-right: 0px;
  }
  @media (min-width: 1200px) {
    width: 25px;
    height: 25px;
  }
`;
export const FaceBIcon = styled(RiFacebookLine)`
  width: 18px;
  height: 18px;
  color: #ffffff;
  border-radius: 10%;
  border: 1px solid #ffffff;
  transition: color 0.3s;
  margin-right: 8px;
  @media (min-width: 768px) {
    margin-right: 0px;
  }
  @media (min-width: 1200px) {
    width: 25px;
    height: 25px;
  }
`;
export const TelegramIcon = styled(LiaTelegramPlane)`
  width: 20px;
  height: 20px;
  color: #ffffff;
  transition: color 0.3s;
  margin-right: 8px;
  @media (min-width: 768px) {
    margin-right: 0px;
  }
  @media (min-width: 1200px) {
    width: 25px;
    height: 25px;
  }
`;
export const PhoneIcon = styled(LiaPhoneVolumeSolid)`
  width: 18px;
  height: 18px;
  color: #ffffff;
  border-radius: 10%;
  border: 1px solid #ffffff;
  transition: color 0.3s;
  @media (min-width: 1200px) {
    width: 25px;
    height: 25px;
  }
`;

export const NavItemIcons = styled.li`
  list-style-type: none;
  cursor: pointer;
  display: flex;
  margin-bottom: 10px;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 66px;
  color: #ffffff;
  @media (min-width: 768px) {
    font-size: 10px;
    line-height: 66px;
    margin-right: 30px;
  }
`;
